<template>
  <div class="index-item-page">
    <!-- 讲师 -->
    <div class="oto-content"
         v-if='type == 3 || type == 4'>
      <div class="oc-item"
           v-for="(it,idx) in list"
           :key="idx"
           @click="toTeach(it.teacher_id)">
        <img :src="it.teacher_avatar" />
        <div>
          <p>
            <span>{{it.teacher_name}}</span>
            <font v-if="it.level_name">{{it.level_name}}</font>
          </p>
          <p>{{it.introduction}}</p>
        </div>
      </div>
    </div>
    <!-- 资讯 -->
    <ul class="news-content"
        v-if="type == 5">
      <router-link tag="li"
                   v-for="(it, index) in list"
                   :key="index"
                   :to="{ name: 'NewsDetail', query: { id: it.id } }">
        <img :src="it.thumb_img" />
        <div>
          <p class="name">{{ it.title }}</p>
          <p class="desc">{{ it.description }}</p>
          <div>
            <p class="number">{{ it.click_rate }}</p>
            <p class="time">
              {{ it.created_at | fomartTime("yyyy-MM-dd hh:mm:ss") }}
            </p>
          </div>
        </div>
      </router-link>
    </ul>
    <!-- 图书 -->
    <div class="book-list"
         v-if='type == 6'>
      <router-link class="bl-item"
                   :to="{ name: 'BookDetail', query: { id: book.id } }"
                   v-for="(book,index) in list"
                   :key="index">
        <img class="bli-cover"
             :src="book.cover_img" />
        <div>
          <div>
            <p class="bli-title">
              <span class="tuan-icon"
                    v-if="book.is_spell"></span>
              <span class="quan-icon"
                    v-if="book.is_has_coupon"></span>
              <font>{{book.title}}</font>
            </p>
            <p class="bli-author">作者：{{book.author}}</p>
            <p class="bli-stock">{{book.total_sales_num }}人已购买 &nbsp;&nbsp;|&nbsp;&nbsp; 剩余库存：{{book.stock}} </p>
          </div>
          <p class="bli-price" v-if="book.is_spell">
              <icon-price v-if="book.spell_price"
                          :priceType="2"></icon-price>
              <span v-if="book.spell_price">{{book.spell_price | toFixPrice}}</span>
              <icon-price v-if="book.underlined_price"
                          :priceType="2"></icon-price>
              <span class="under-line"
                    v-if="book.underlined_price">{{book.underlined_price | toFixPrice}}</span>
            </p>
            <p class="bli-price" v-else>
              <icon-price v-if="book.price"
                          :priceType="2"></icon-price>
              <span v-if="book.price">{{book.price | toFixPrice}}</span>
              <span v-else
                    class="is_free">免费</span>
              <icon-price v-if="book.underlined_price"
                          :priceType="2"></icon-price>
              <span class="under-line"
                    v-if="book.underlined_price">{{book.underlined_price | toFixPrice}}</span>
            </p>
        </div>
      </router-link>
    </div>
    <!-- 章节练习、模拟考试 -->
    <ul class="exam"
        v-if='type == 7 || type == 8'>
      <router-link tag="li"
                   v-for="(it, index) in list"
                   :key="index"
                   :to="routerLink(type,it)">
        <div class="content">
          <div class="indexpic">
            <img :src="it.cover_img">
          </div>
          <div class="right_conten">
            <div class="name">
              <p>{{it.title}}</p>
              <span v-if="it.related_course_id"
                    class="is_student_free">学员免费</span>
            </div>
            <div class="price">
              <span class="total_sales_num">{{$pub.setUnit(it.total_sales_num)}}人购买</span>
              <span class="is_free"
                    v-if="it.is_free">免费</span>
              <span class="no_free"
                    v-if="!it.is_free">
                <icon-price size="middle"
                            :priceType="it.type == 12 ? 2 : 1"></icon-price>
                <span class="no_free">{{$pub.setUnit((it.price / 100))}}</span>
              </span>
            </div>
          </div>
        </div>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { CourseType } from "@/util/enums";
export default {
  name: "RecommendItem",
  props: {
    list: {
      type: Array
    },
    type: {
      type: Number,
    }
  },
  data () {
    return {
    };
  },
  created () {
  },
  methods: {
    routerLink (type, item) {
      let query = { name: 'ExerciseDetail', query: { id: item.id } };
      if (type == 8) {
        query = { name: 'ExamDetail', query: { id: item.id, type: 'Exam' } }
      }
      return query;
    },
    toTeach (id) {
      this.$router.push({ name: 'Teacher', query: { id: id } })
    }
  }
};
</script>

<style lang="scss" scoped>
.index-item-page {
  .oto-content {
    padding: 10px 20px 40px;
    .oc-item {
      display: flex;
      align-items: center;
      padding: 0 30px;
      background: #fff;
      border-radius: 8px;
      height: 162px;
      margin-top: 20px;
      img {
        width: 80px;
        height: 80px;
        margin-right: 24px;
        border-radius: 50%;
        flex: none;
      }
      div {
        flex: 1;
        p {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          &:nth-child(1) {
            padding-bottom: 6px;
            span {
              font-size: 30px;
              color: #595959;
              line-height: 42px;
              padding-right: 10px;
            }
            font {
              font-size: 22px;
              color: rgba(234, 122, 47, 1);
            }
          }
          &:nth-child(2) {
            width: 550px;
            font-size: 24px;
            height: 30px;
            padding-top: 10px;
            color: rgba(183, 183, 183, 1);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      a {
        flex: none;
        width: 140px;
        height: 62px;
        line-height: 62px;
        background: rgba(235, 238, 254, 1);
        border-radius: 31px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: $theme_color;
        border: none;
        text-align: center;
      }
    }
  }
  .news-content {
    padding: 30px;
    li {
      padding: 20px;
      margin-bottom: 30px;
      background: #fff;
      box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.07);
      border-radius: 20px;
      display: flex;
      align-items: center;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        display: block;
        width: 208px;
        height: 129px;
        border-radius: 10px;
        flex: none;
        margin-right: 24px;
      }
      & > div {
        overflow: hidden;
        width: 100%;
        .name {
          @include eps;
          // margin-bottom: 20px;
          font-size: 28px;
          font-weight: 500;
          color: #333;
          line-height: 42px;
          height: 42px;
        }
        .desc {
          @include eps;
          // height: 60px;
          width: 100%;
          font-size: 24px;
          color: #999;
          line-height: 30px;
        }
        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 35px;
          p {
            font-size: 22px;
            color: #999;
            line-height: 22px;
          }
          .number {
            padding: 0 0 0 34px;
            background: url("~@/assets/images/icon-eye.png") left center
              no-repeat;
            background-size: 25px 17px;
          }
          .time {
            padding: 0 0 0 26px;
            background: url("~@/assets/images/icon-time.png") left center
              no-repeat;
            background-size: 17px 17px;
          }
        }
      }
    }
  }
  .book-list {
    margin-top: 30px;
    // padding: 30px;
    .bl-item {
      height: 300px;
      background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
      // border-radius: 12px;
      display: flex;
      padding-left: 30px;
      padding-bottom: 30px;
      &:last-child {
        margin: 0;
      }
      .bli-cover {
        width: 180px;
        height: 240px;
        margin-top: 30px;
        margin-right: 30px;
        flex: none;
      }
      > div {
        height: 280px;
        margin-top: 30px;
        width: 480px;
        border-bottom: 1px solid #f6f6f6;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        position: relative;
        .bli-title {
          // margin-top: 30px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333;
          line-height: 40px;
          max-height: 80px;
          overflow: hidden;
          .quan-icon,
          .tuan-icon {
            width: 35px;
            height: 35px;
            background: url("~@/assets/images/quan@2x.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
            display: inline-block;
            vertical-align: middle;
          }
          .tuan-icon {
            background: url("~@/assets/images/tuan@2x.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        .bli-author {
          margin-top: 20px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999;
          line-height: 40px;
        }
        .bli-stock {
          font-size: 24px;
          color: #999;
          margin-top: 24px;
        }
        .bli-price {
          position: absolute;
          bottom: 10px;
          span {
            margin-right: 10px;
          }
          /deep/ .price-ico {
            width: 16px;
            margin: 0 4px;
          }
          .under-line {
            font-size: 24px;
            color: #979797;
            text-decoration: line-through;
          }
          .is_free {
            color: #65ae58;
          }
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(238, 31, 31, 1);
          line-height: 32px;
          padding-bottom: 30px;
        }
      }
    }
    & > div:last-child {
      & > div {
        border: none;
      }
    }
  }
  .exam {
    li {
      padding: 30px;
      background: #fff;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;
      .content {
        .indexpic {
          width: 220px;
          height: 220px;
          float: left;
          img {
            width: 100%;
            height: 220px;
          }
        }
        .right_conten {
          color: #3d3a39;
          font-size: 30px;
          line-height: 33px;
          margin-left: 240px;
          font-weight: 500;
          .name {
            height: 160px;
            p {
              @include lines-eps(3);
            }
            .is_student_free {
              margin-top: 23px;
              color: $theme_color;
              font-size: 24px;
              display: inline-block;
              width: 120px;
              height: 42px;
              border-radius: 4px;
              text-align: center;
              line-height: 42px;
              border: 1px solid $theme_color;
            }
          }
          .price {
            font-weight: 500;
            overflow: hidden;
            margin-top: 30px;
            .total_sales_num {
              float: left;
              color: #999999;
              font-size: 24px;
            }
            .is_free,
            .no_free {
              float: right;
              font-size: 32px;
            }
            .is_free {
              color: #65ae58;
            }
            .no_free {
              color: #e62e2a;
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
